var _path, _path2, _path3, _circle, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _g2, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g3, _path33, _path34, _path35, _path36, _path37, _path38, _g4, _path39, _path40, _path41, _g5, _path42, _path43, _path44, _path45, _path46, _path47, _g6, _path48, _path49, _path50, _path51, _g7, _path52, _path53, _path54, _g8, _path55, _path56, _path57, _path58, _g9, _path59, _path60, _path61, _path62, _path63, _path64, _g10, _path65, _path66, _path67, _path68, _g11, _path69, _path70, _path71, _g12, _path72, _path73, _path74, _path75, _path76, _path77, _ellipse, _ellipse2, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 210,
    viewBox: "0 0 280 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.609 32.5272C182.609 25.2784 188.485 19.4022 195.734 19.4022C202.983 19.4022 208.859 25.2784 208.859 32.5272C208.859 39.7759 202.983 45.6522 195.734 45.6522C188.485 45.6522 182.609 39.7759 182.609 32.5272ZM192.02 34.0657C192.642 35.5679 194.108 36.5475 195.734 36.5474C196.8 36.5475 197.823 36.1239 198.577 35.3699C199.331 34.616 199.754 33.5934 199.754 32.5272C199.754 30.9011 198.775 29.4352 197.273 28.8129C195.77 28.1907 194.041 28.5346 192.891 29.6844C191.741 30.8342 191.398 32.5634 192.02 34.0657Z",
    fill: "#CDE2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6797 110.136C25.6797 102.887 31.5559 97.0109 38.8047 97.0109C46.0534 97.0109 51.9297 102.887 51.9297 110.136C51.9297 117.385 46.0534 123.261 38.8047 123.261C31.5559 123.261 25.6797 117.385 25.6797 110.136ZM35.0902 111.674C35.7125 113.177 37.1784 114.156 38.8045 114.156C39.8707 114.156 40.8933 113.733 41.6473 112.979C42.4012 112.225 42.8248 111.202 42.8248 110.136C42.8248 108.51 41.8453 107.044 40.343 106.422C38.8407 105.799 37.1115 106.143 35.9617 107.293C34.8119 108.443 34.468 110.172 35.0902 111.674Z",
    fill: "#CDE2FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.321 125.6C238.336 123.148 240.729 121.549 243.383 121.549C245.124 121.549 246.793 122.24 248.024 123.471C249.254 124.702 249.946 126.371 249.946 128.111C249.946 130.766 248.347 133.158 245.895 134.174C243.443 135.19 240.62 134.628 238.743 132.752C236.866 130.875 236.305 128.052 237.321 125.6ZM241.373 128.111C241.373 129.221 242.273 130.121 243.383 130.121C243.917 130.121 244.428 129.91 244.805 129.533C245.182 129.156 245.394 128.644 245.394 128.111C245.394 127.001 244.494 126.101 243.383 126.101C242.273 126.101 241.373 127.001 241.373 128.111Z",
    fill: "#CDE2FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 198.016,
    cy: 74.1848,
    r: 3.42391,
    fill: "#AED3FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.435,
    cy: 144.946,
    r: 3.42391,
    fill: "#AED3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3145 37.8009H77.4707V34.9572C77.4707 33.9303 76.6382 33.0978 75.6113 33.0978C74.5844 33.0978 73.752 33.9303 73.752 34.9572V37.8009H70.9082C69.8813 37.801 69.0488 38.6334 69.0488 39.6603C69.0488 40.6872 69.8813 41.5197 70.9082 41.5197H73.752V44.3635C73.752 45.3904 74.5844 46.2228 75.6113 46.2228C76.6382 46.2228 77.4707 45.3904 77.4707 44.3635V41.5197H80.3145C81.3414 41.5197 82.1738 40.6872 82.1738 39.6603C82.1738 38.6334 81.3414 37.801 80.3145 37.8009Z",
    fill: "#0084F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.619 88.589H168.775V85.7453C168.775 84.7184 167.942 83.8859 166.916 83.8859C165.889 83.8859 165.056 84.7184 165.056 85.7453V88.589H162.212C161.186 88.589 160.353 89.4215 160.353 90.4483C160.353 91.4752 161.186 92.3077 162.212 92.3077H165.056V95.1515C165.056 96.1784 165.889 97.0109 166.916 97.0109C167.942 97.0109 168.775 96.1784 168.775 95.1515V92.3078H171.619C172.112 92.3078 172.585 92.1119 172.933 91.7631C173.282 91.4144 173.478 90.9415 173.478 90.4483C173.478 89.4215 172.646 88.589 171.619 88.589Z",
    fill: "#D9E9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.744 173.616H181.9V170.772C181.9 169.745 181.067 168.913 180.041 168.913C179.014 168.913 178.181 169.745 178.181 170.772V173.616H175.337C174.311 173.616 173.478 174.449 173.478 175.476C173.478 176.502 174.311 177.335 175.337 177.335H178.181V180.179C178.181 181.206 179.014 182.038 180.041 182.038C181.067 182.038 181.9 181.206 181.9 180.179V177.335H184.744C185.771 177.335 186.603 176.502 186.603 175.476C186.603 174.982 186.407 174.509 186.058 174.161C185.71 173.812 185.237 173.616 184.744 173.616Z",
    fill: "#0084F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7522 152.061L71.199 151.508L71.7522 150.955C71.952 150.755 71.952 150.431 71.7522 150.231C71.5525 150.032 71.2285 150.032 71.0287 150.231L70.4755 150.785L69.9222 150.231C69.7224 150.032 69.3985 150.032 69.1987 150.231C68.9989 150.431 68.9989 150.755 69.1987 150.955L69.7519 151.508L69.1987 152.061C68.9989 152.261 68.9989 152.585 69.1987 152.785C69.3985 152.985 69.7224 152.985 69.9222 152.785L70.4755 152.232L71.0287 152.785C71.2285 152.985 71.5525 152.985 71.7522 152.785C71.952 152.585 71.952 152.261 71.7522 152.061Z",
    fill: "#0084F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M144.375 38.519C144.376 38.1842 144.171 37.8834 143.858 37.7623C141.155 36.7403 139.021 34.6062 137.999 31.9027C137.878 31.5905 137.577 31.3851 137.242 31.3859C136.907 31.3851 136.606 31.5905 136.485 31.9027C135.463 34.6062 133.329 36.7403 130.626 37.7623C130.314 37.8834 130.108 38.1842 130.109 38.519C130.108 38.8539 130.314 39.1546 130.626 39.2757C133.329 40.2977 135.463 42.4319 136.485 45.1354C136.606 45.4476 136.907 45.653 137.242 45.6522C137.577 45.653 137.878 45.4476 137.999 45.1354C139.021 42.4319 141.155 40.2977 143.858 39.2757C144.171 39.1546 144.376 38.8538 144.375 38.519Z",
    fill: "#D9E9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.522 81.3179C246.522 80.9831 246.317 80.6823 246.005 80.5612C243.301 79.5392 241.167 77.4051 240.145 74.7016C240.024 74.3894 239.723 74.184 239.389 74.1848C239.054 74.184 238.753 74.3894 238.632 74.7016C237.61 77.4051 235.476 79.5393 232.772 80.5612C232.46 80.6823 232.255 80.9831 232.255 81.3179C232.255 81.6528 232.46 81.9535 232.772 82.0746C235.476 83.0966 237.61 85.2308 238.632 87.9343C238.753 88.2465 239.054 88.4519 239.389 88.4511C239.723 88.4519 240.024 88.2465 240.145 87.9343C241.167 85.2308 243.301 83.0966 246.005 82.0746C246.317 81.9535 246.522 81.6528 246.522 81.3179Z",
    fill: "#D9E9FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 280,
    height: 210
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 279.62,
    height: 210,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_1587)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M229.473 46.0205C229.481 38.5901 224.723 31.9947 217.676 29.6675C216.729 21.067 209.478 14.3771 200.671 14.3771C195.312 14.3771 190.531 16.8545 187.393 20.7303C185.582 19.9476 183.629 19.5448 181.656 19.5468C175.42 19.5468 170.102 23.4948 168.036 29.0395C159.888 30.3586 153.664 37.4576 153.664 46.0205C153.664 55.5217 161.326 63.224 170.777 63.224V63.2407H213.577V63.176C222.46 62.5481 229.473 55.1101 229.473 46.0205Z",
    fill: "#004E9C",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M209.255 45.4823L193.069 26.3852C192.695 25.9436 192.147 25.689 191.569 25.689C190.991 25.689 190.442 25.9436 190.069 26.3852L173.882 45.4823C172.792 46.7684 173.701 48.748 175.382 48.748H185.273V69.3223H197.864V48.748H207.755C209.436 48.748 210.345 46.7684 209.255 45.4823Z",
    fill: "white",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.859 173.868L84.7554 173.895L135.554 122.745L171.24 140.015L196.162 101.262L210.47 110.562L177.388 162.003L139.064 143.453L108.859 173.868Z",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 101,
    width: 127,
    height: 73
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.859 173.868L84.7554 173.895L135.554 122.745L171.24 140.015L196.162 101.262L210.47 110.562L177.388 162.003L139.064 143.453L108.859 173.868Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_1587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 192,
    y: 101,
    width: 32,
    height: 46
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.162 101.262C183.484 104.3 211.704 109.074 196.465 136.9C181.227 164.726 223.838 121.541 223.838 121.541L216.219 104.584",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.981 118.838C192.809 118.837 192.654 118.94 192.588 119.099C192.522 119.257 192.558 119.44 192.679 119.562C192.8 119.683 192.982 119.72 193.141 119.654C193.299 119.589 193.403 119.434 193.403 119.262C193.403 119.15 193.359 119.042 193.279 118.963C193.2 118.883 193.093 118.838 192.981 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 118.838C195.168 118.837 195.013 118.94 194.947 119.099C194.881 119.257 194.917 119.44 195.038 119.562C195.159 119.683 195.341 119.72 195.5 119.654C195.658 119.589 195.762 119.434 195.762 119.262C195.762 119.15 195.717 119.042 195.638 118.963C195.559 118.883 195.452 118.838 195.339 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 118.838C197.526 118.837 197.371 118.94 197.305 119.099C197.239 119.257 197.274 119.44 197.395 119.562C197.517 119.683 197.699 119.72 197.858 119.654C198.016 119.589 198.12 119.434 198.12 119.262C198.12 119.028 197.931 118.838 197.697 118.838V118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 118.838C199.885 118.837 199.73 118.94 199.664 119.099C199.597 119.257 199.633 119.44 199.754 119.562C199.875 119.683 200.058 119.72 200.216 119.654C200.375 119.589 200.478 119.434 200.478 119.262C200.479 119.15 200.434 119.042 200.355 118.963C200.276 118.883 200.168 118.838 200.056 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 118.838C202.244 118.837 202.089 118.94 202.022 119.099C201.956 119.257 201.992 119.44 202.113 119.562C202.234 119.683 202.417 119.72 202.575 119.654C202.734 119.589 202.837 119.434 202.837 119.262C202.838 119.15 202.793 119.042 202.714 118.963C202.635 118.883 202.527 118.838 202.415 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 118.838C204.602 118.837 204.447 118.94 204.381 119.099C204.315 119.257 204.351 119.44 204.472 119.562C204.593 119.683 204.775 119.72 204.934 119.654C205.092 119.589 205.196 119.434 205.196 119.262C205.196 119.028 205.007 118.838 204.774 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 118.838C206.96 118.837 206.805 118.94 206.739 119.099C206.673 119.257 206.709 119.44 206.83 119.562C206.951 119.683 207.134 119.72 207.292 119.654C207.451 119.589 207.554 119.434 207.554 119.262C207.554 119.15 207.51 119.042 207.431 118.963C207.352 118.883 207.244 118.838 207.132 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 118.838C209.319 118.837 209.164 118.94 209.098 119.099C209.032 119.257 209.068 119.44 209.189 119.562C209.31 119.683 209.492 119.72 209.651 119.654C209.81 119.589 209.913 119.434 209.913 119.262C209.913 119.028 209.724 118.838 209.491 118.838Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 123.329C192.809 123.328 192.654 123.431 192.588 123.59C192.522 123.748 192.558 123.931 192.679 124.053C192.8 124.174 192.982 124.211 193.141 124.145C193.299 124.08 193.403 123.925 193.403 123.753C193.403 123.641 193.359 123.533 193.279 123.453C193.2 123.374 193.093 123.329 192.981 123.329Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 123.753,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 123.329C197.526 123.328 197.371 123.431 197.305 123.59C197.239 123.748 197.275 123.931 197.396 124.053C197.517 124.174 197.699 124.211 197.858 124.145C198.017 124.08 198.12 123.925 198.12 123.753C198.12 123.519 197.931 123.329 197.698 123.329Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 123.753,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 123.753,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 123.753,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 123.753,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 123.753,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 125.574C192.809 125.573 192.654 125.676 192.588 125.835C192.522 125.993 192.558 126.176 192.679 126.298C192.8 126.42 192.982 126.456 193.141 126.391C193.299 126.325 193.403 126.17 193.403 125.998C193.403 125.886 193.359 125.778 193.279 125.699C193.2 125.619 193.093 125.574 192.981 125.574Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 125.998,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 125.574C197.526 125.573 197.371 125.676 197.305 125.835C197.239 125.993 197.275 126.176 197.396 126.298C197.517 126.42 197.699 126.456 197.858 126.391C198.017 126.325 198.12 126.17 198.12 125.998C198.12 125.765 197.931 125.575 197.698 125.574Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 125.998,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 125.998,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 125.998,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 125.998,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 125.998,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 114.347C192.809 114.346 192.654 114.449 192.588 114.608C192.522 114.766 192.558 114.949 192.679 115.071C192.8 115.193 192.982 115.229 193.141 115.164C193.299 115.098 193.403 114.943 193.403 114.771C193.403 114.659 193.359 114.551 193.279 114.472C193.2 114.392 193.093 114.347 192.981 114.347Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 114.771,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 114.347C197.526 114.346 197.371 114.449 197.305 114.608C197.239 114.766 197.274 114.949 197.395 115.071C197.517 115.193 197.699 115.229 197.858 115.164C198.016 115.098 198.12 114.943 198.12 114.771C198.12 114.538 197.931 114.348 197.698 114.347Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 114.771,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 114.771,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 114.771,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 114.771,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 114.771,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 116.592C192.809 116.592 192.654 116.695 192.588 116.853C192.522 117.012 192.558 117.195 192.679 117.316C192.8 117.438 192.982 117.475 193.141 117.409C193.299 117.343 193.403 117.189 193.403 117.017C193.403 116.905 193.359 116.797 193.279 116.717C193.2 116.638 193.093 116.593 192.981 116.592Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 117.017,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 116.592C197.526 116.592 197.371 116.695 197.305 116.853C197.239 117.012 197.274 117.195 197.395 117.316C197.517 117.438 197.699 117.475 197.858 117.409C198.016 117.344 198.12 117.189 198.12 117.017C198.12 116.783 197.931 116.593 197.698 116.592Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 117.017,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 117.017,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 117.017,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 117.017,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 117.017,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 121.083C192.809 121.083 192.654 121.186 192.588 121.344C192.522 121.503 192.558 121.685 192.679 121.807C192.8 121.929 192.982 121.965 193.141 121.9C193.299 121.834 193.403 121.679 193.403 121.508C193.403 121.395 193.359 121.288 193.279 121.208C193.2 121.128 193.093 121.084 192.981 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 121.083C195.168 121.083 195.013 121.186 194.947 121.344C194.881 121.503 194.917 121.685 195.038 121.807C195.159 121.929 195.341 121.965 195.5 121.9C195.658 121.834 195.762 121.679 195.762 121.508C195.762 121.274 195.573 121.084 195.339 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 121.083C197.526 121.083 197.371 121.186 197.305 121.344C197.239 121.503 197.275 121.685 197.396 121.807C197.517 121.929 197.699 121.965 197.858 121.9C198.017 121.834 198.12 121.679 198.12 121.508C198.12 121.274 197.931 121.084 197.698 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 121.083C199.885 121.083 199.73 121.186 199.664 121.344C199.597 121.503 199.633 121.685 199.754 121.807C199.876 121.929 200.058 121.965 200.216 121.9C200.375 121.834 200.478 121.679 200.478 121.508C200.479 121.274 200.29 121.084 200.056 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 121.083C202.244 121.083 202.089 121.186 202.022 121.344C201.956 121.503 201.992 121.685 202.113 121.807C202.234 121.929 202.417 121.965 202.575 121.9C202.734 121.834 202.837 121.679 202.837 121.508C202.838 121.274 202.649 121.084 202.415 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 121.083C204.602 121.083 204.447 121.186 204.381 121.344C204.315 121.503 204.351 121.685 204.472 121.807C204.593 121.929 204.775 121.965 204.934 121.9C205.092 121.834 205.196 121.679 205.196 121.508C205.196 121.274 205.007 121.084 204.774 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 121.083C206.96 121.083 206.805 121.186 206.739 121.344C206.673 121.503 206.709 121.685 206.83 121.807C206.951 121.929 207.134 121.965 207.292 121.9C207.451 121.834 207.554 121.679 207.554 121.508C207.554 121.274 207.365 121.084 207.132 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 121.083C209.319 121.083 209.164 121.186 209.098 121.344C209.032 121.503 209.068 121.685 209.189 121.807C209.31 121.929 209.492 121.965 209.651 121.9C209.81 121.834 209.913 121.679 209.913 121.508C209.913 121.274 209.724 121.084 209.491 121.083Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 127.82C192.809 127.819 192.654 127.922 192.588 128.08C192.522 128.239 192.558 128.422 192.679 128.543C192.8 128.665 192.982 128.702 193.141 128.636C193.299 128.57 193.403 128.416 193.403 128.244C193.403 128.132 193.359 128.024 193.279 127.944C193.2 127.865 193.093 127.82 192.981 127.82V127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 127.82C195.168 127.819 195.013 127.922 194.947 128.08C194.881 128.239 194.917 128.422 195.038 128.543C195.159 128.665 195.341 128.702 195.5 128.636C195.658 128.57 195.762 128.416 195.762 128.244C195.762 128.132 195.717 128.024 195.638 127.944C195.559 127.865 195.452 127.82 195.339 127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 127.82C197.526 127.819 197.371 127.922 197.305 128.08C197.239 128.239 197.274 128.422 197.395 128.543C197.517 128.665 197.699 128.702 197.857 128.636C198.016 128.571 198.12 128.416 198.12 128.244C198.12 128.01 197.931 127.82 197.697 127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 127.82C199.885 127.819 199.73 127.922 199.664 128.08C199.597 128.239 199.633 128.422 199.754 128.543C199.875 128.665 200.058 128.702 200.216 128.636C200.375 128.57 200.478 128.416 200.478 128.244C200.479 128.132 200.434 128.024 200.355 127.944C200.276 127.865 200.168 127.82 200.056 127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 127.82C202.244 127.819 202.089 127.922 202.022 128.08C201.956 128.239 201.992 128.422 202.113 128.543C202.234 128.665 202.417 128.702 202.575 128.636C202.734 128.57 202.837 128.416 202.837 128.244C202.838 128.132 202.793 128.024 202.714 127.944C202.635 127.865 202.527 127.82 202.415 127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 127.82C204.602 127.819 204.447 127.922 204.381 128.08C204.315 128.239 204.351 128.422 204.472 128.543C204.593 128.665 204.775 128.702 204.934 128.636C205.092 128.57 205.196 128.416 205.196 128.244C205.196 128.01 205.007 127.82 204.774 127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 127.82C206.96 127.819 206.805 127.922 206.739 128.08C206.673 128.239 206.709 128.422 206.83 128.543C206.951 128.665 207.134 128.702 207.292 128.636C207.451 128.57 207.554 128.416 207.554 128.244C207.554 128.132 207.51 128.024 207.431 127.944C207.352 127.865 207.244 127.82 207.132 127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 127.82C209.319 127.819 209.164 127.922 209.098 128.08C209.032 128.239 209.068 128.422 209.189 128.543C209.31 128.665 209.492 128.702 209.651 128.636C209.81 128.57 209.913 128.416 209.913 128.244C209.913 128.01 209.724 127.82 209.491 127.82V127.82Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 103.12C192.809 103.12 192.654 103.222 192.588 103.381C192.522 103.539 192.558 103.722 192.679 103.844C192.8 103.966 192.982 104.002 193.141 103.937C193.299 103.871 193.403 103.716 193.403 103.544C193.403 103.432 193.359 103.324 193.279 103.245C193.2 103.165 193.093 103.12 192.981 103.12Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 103.544,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 103.12C197.526 103.119 197.371 103.222 197.305 103.381C197.239 103.539 197.275 103.722 197.396 103.844C197.517 103.966 197.699 104.002 197.858 103.937C198.017 103.871 198.12 103.716 198.12 103.544C198.12 103.311 197.931 103.121 197.698 103.12Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 103.544,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 103.544,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 103.544,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 103.544,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 103.544,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 107.611C192.809 107.61 192.654 107.713 192.588 107.872C192.522 108.03 192.558 108.213 192.679 108.335C192.8 108.456 192.982 108.493 193.141 108.427C193.299 108.362 193.403 108.207 193.403 108.035C193.403 107.923 193.359 107.815 193.279 107.736C193.2 107.656 193.093 107.611 192.981 107.611Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 108.035,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 107.611C197.526 107.61 197.371 107.713 197.305 107.872C197.239 108.03 197.275 108.213 197.396 108.335C197.517 108.456 197.699 108.493 197.858 108.427C198.017 108.362 198.12 108.207 198.12 108.035C198.12 107.801 197.931 107.611 197.698 107.611Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 108.035,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 108.035,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 108.035,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 108.035,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 108.035,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 109.856C192.809 109.856 192.654 109.959 192.588 110.117C192.522 110.276 192.558 110.458 192.679 110.58C192.8 110.702 192.982 110.738 193.141 110.673C193.299 110.607 193.403 110.452 193.403 110.281C193.403 110.168 193.359 110.061 193.279 109.981C193.2 109.901 193.093 109.857 192.981 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 109.856C195.168 109.856 195.013 109.959 194.947 110.117C194.881 110.276 194.917 110.458 195.038 110.58C195.159 110.702 195.341 110.738 195.5 110.673C195.658 110.607 195.762 110.452 195.762 110.281C195.762 110.168 195.717 110.061 195.638 109.981C195.559 109.901 195.452 109.857 195.339 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 109.856C197.526 109.856 197.371 109.959 197.305 110.117C197.239 110.276 197.274 110.458 197.395 110.58C197.517 110.702 197.699 110.738 197.858 110.673C198.016 110.607 198.12 110.452 198.12 110.281C198.12 110.047 197.931 109.857 197.697 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 109.856C199.885 109.856 199.73 109.959 199.664 110.117C199.597 110.276 199.633 110.458 199.754 110.58C199.875 110.702 200.058 110.738 200.216 110.673C200.375 110.607 200.478 110.452 200.478 110.281C200.479 110.168 200.434 110.061 200.355 109.981C200.276 109.901 200.168 109.857 200.056 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 109.856C202.244 109.856 202.089 109.959 202.022 110.117C201.956 110.276 201.992 110.458 202.113 110.58C202.234 110.702 202.417 110.738 202.575 110.673C202.734 110.607 202.837 110.452 202.837 110.281C202.838 110.168 202.793 110.061 202.714 109.981C202.635 109.901 202.527 109.857 202.415 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 109.856C204.602 109.856 204.447 109.959 204.381 110.117C204.315 110.276 204.351 110.458 204.472 110.58C204.593 110.702 204.775 110.738 204.934 110.673C205.092 110.607 205.196 110.452 205.196 110.281C205.196 110.047 205.007 109.857 204.774 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 109.856C206.96 109.856 206.805 109.959 206.739 110.117C206.673 110.276 206.709 110.458 206.83 110.58C206.951 110.702 207.134 110.738 207.292 110.673C207.451 110.607 207.554 110.452 207.554 110.281C207.554 110.168 207.51 110.061 207.431 109.981C207.352 109.901 207.244 109.857 207.132 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 109.856C209.319 109.856 209.164 109.959 209.098 110.117C209.032 110.276 209.068 110.458 209.189 110.58C209.31 110.702 209.492 110.738 209.651 110.673C209.81 110.607 209.913 110.452 209.913 110.281C209.913 110.047 209.724 109.857 209.491 109.856Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 100.875C192.809 100.874 192.654 100.977 192.588 101.136C192.522 101.294 192.558 101.477 192.679 101.599C192.8 101.72 192.982 101.757 193.141 101.691C193.299 101.626 193.403 101.471 193.403 101.299C193.403 101.187 193.359 101.079 193.279 100.999C193.2 100.92 193.093 100.875 192.981 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 100.875C195.168 100.874 195.013 100.977 194.947 101.136C194.881 101.294 194.917 101.477 195.038 101.599C195.159 101.72 195.341 101.757 195.5 101.691C195.658 101.626 195.762 101.471 195.762 101.299C195.762 101.187 195.717 101.079 195.638 100.999C195.559 100.92 195.452 100.875 195.339 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 100.875C197.526 100.874 197.371 100.977 197.305 101.135C197.239 101.294 197.274 101.477 197.396 101.599C197.517 101.72 197.699 101.757 197.858 101.691C198.016 101.626 198.12 101.471 198.12 101.299C198.12 101.065 197.931 100.875 197.697 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 100.875C199.885 100.874 199.73 100.977 199.664 101.136C199.597 101.294 199.633 101.477 199.754 101.599C199.875 101.72 200.058 101.757 200.216 101.691C200.375 101.626 200.478 101.471 200.478 101.299C200.479 101.187 200.434 101.079 200.355 100.999C200.276 100.92 200.168 100.875 200.056 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 100.875C202.244 100.874 202.089 100.977 202.022 101.136C201.956 101.294 201.992 101.477 202.113 101.599C202.234 101.72 202.417 101.757 202.575 101.691C202.734 101.626 202.837 101.471 202.837 101.299C202.838 101.187 202.793 101.079 202.714 100.999C202.635 100.92 202.527 100.875 202.415 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 100.875C204.602 100.874 204.447 100.977 204.381 101.136C204.315 101.294 204.351 101.477 204.472 101.599C204.593 101.72 204.775 101.757 204.934 101.691C205.092 101.626 205.196 101.471 205.196 101.299C205.196 101.065 205.007 100.875 204.774 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 100.875C206.96 100.874 206.805 100.977 206.739 101.136C206.673 101.294 206.709 101.477 206.83 101.599C206.951 101.72 207.134 101.757 207.292 101.691C207.451 101.626 207.554 101.471 207.554 101.299C207.554 101.187 207.51 101.079 207.431 100.999C207.352 100.92 207.244 100.875 207.132 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 100.875C209.319 100.874 209.164 100.977 209.098 101.136C209.032 101.294 209.068 101.477 209.189 101.599C209.31 101.72 209.492 101.757 209.651 101.691C209.81 101.626 209.913 101.471 209.913 101.299C209.913 101.065 209.724 100.875 209.491 100.875Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 105.366C192.809 105.365 192.654 105.468 192.588 105.626C192.522 105.785 192.558 105.968 192.679 106.089C192.8 106.211 192.982 106.248 193.141 106.182C193.299 106.116 193.403 105.962 193.403 105.79C193.403 105.678 193.359 105.57 193.279 105.49C193.2 105.411 193.093 105.366 192.981 105.366Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 105.79,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 105.366C197.526 105.365 197.371 105.468 197.305 105.626C197.239 105.785 197.275 105.968 197.396 106.089C197.517 106.211 197.699 106.248 197.858 106.182C198.017 106.116 198.12 105.962 198.12 105.79C198.12 105.556 197.931 105.366 197.698 105.366Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 105.79,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 105.79,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 105.79,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 105.79,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 105.79,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 112.102C192.809 112.101 192.654 112.204 192.588 112.363C192.522 112.521 192.558 112.704 192.679 112.826C192.8 112.947 192.982 112.984 193.141 112.918C193.299 112.853 193.403 112.698 193.403 112.526C193.403 112.414 193.359 112.306 193.279 112.226C193.2 112.147 193.093 112.102 192.981 112.102V112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 112.102C195.168 112.101 195.013 112.204 194.947 112.363C194.881 112.521 194.917 112.704 195.038 112.826C195.159 112.947 195.341 112.984 195.5 112.918C195.658 112.853 195.762 112.698 195.762 112.526C195.762 112.414 195.717 112.306 195.638 112.226C195.559 112.147 195.452 112.102 195.339 112.102V112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 112.102C197.526 112.101 197.371 112.204 197.305 112.362C197.239 112.521 197.274 112.704 197.395 112.825C197.517 112.947 197.699 112.984 197.858 112.918C198.016 112.853 198.12 112.698 198.12 112.526C198.12 112.292 197.931 112.102 197.697 112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 112.102C199.885 112.101 199.73 112.204 199.664 112.363C199.597 112.521 199.633 112.704 199.754 112.826C199.875 112.947 200.058 112.984 200.216 112.918C200.375 112.853 200.478 112.698 200.478 112.526C200.479 112.414 200.434 112.306 200.355 112.226C200.276 112.147 200.168 112.102 200.056 112.102V112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 112.102C202.244 112.101 202.089 112.204 202.022 112.363C201.956 112.521 201.992 112.704 202.113 112.826C202.234 112.947 202.417 112.984 202.575 112.918C202.734 112.853 202.837 112.698 202.837 112.526C202.838 112.414 202.793 112.306 202.714 112.226C202.635 112.147 202.527 112.102 202.415 112.102V112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 112.102C204.602 112.101 204.447 112.204 204.381 112.363C204.315 112.521 204.351 112.704 204.472 112.826C204.593 112.947 204.775 112.984 204.934 112.918C205.092 112.853 205.196 112.698 205.196 112.526C205.196 112.292 205.007 112.102 204.774 112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 112.102C206.96 112.101 206.805 112.204 206.739 112.363C206.673 112.521 206.709 112.704 206.83 112.826C206.951 112.947 207.134 112.984 207.292 112.918C207.451 112.853 207.554 112.698 207.554 112.526C207.554 112.414 207.51 112.306 207.431 112.226C207.352 112.147 207.244 112.102 207.132 112.102V112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 112.102C209.319 112.101 209.164 112.204 209.098 112.363C209.032 112.521 209.068 112.704 209.189 112.826C209.31 112.947 209.492 112.984 209.651 112.918C209.81 112.853 209.913 112.698 209.913 112.526C209.913 112.292 209.724 112.102 209.491 112.102Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 143.537C192.809 143.537 192.654 143.64 192.588 143.798C192.522 143.957 192.558 144.139 192.679 144.261C192.8 144.383 192.982 144.419 193.141 144.354C193.299 144.288 193.403 144.133 193.403 143.962C193.403 143.849 193.359 143.742 193.279 143.662C193.2 143.582 193.093 143.538 192.981 143.537Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 143.962,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 143.537C197.526 143.537 197.371 143.64 197.305 143.798C197.239 143.957 197.275 144.139 197.396 144.261C197.517 144.383 197.699 144.419 197.858 144.354C198.017 144.288 198.12 144.133 198.12 143.962C198.12 143.728 197.931 143.538 197.698 143.537Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 143.962,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 143.962,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 143.962,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 143.962,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 143.962,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 134.556C192.809 134.555 192.654 134.658 192.588 134.817C192.522 134.975 192.558 135.158 192.679 135.28C192.8 135.401 192.982 135.438 193.141 135.372C193.299 135.307 193.403 135.152 193.403 134.98C193.403 134.868 193.359 134.76 193.279 134.68C193.2 134.601 193.093 134.556 192.981 134.556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 134.98,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 134.556C197.526 134.555 197.371 134.658 197.305 134.816C197.239 134.975 197.274 135.158 197.395 135.28C197.517 135.401 197.699 135.438 197.858 135.372C198.016 135.307 198.12 135.152 198.12 134.98C198.12 134.746 197.931 134.556 197.698 134.556Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 134.98,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 134.98,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 134.98,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 134.98,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 134.98,
    rx: 0.422128,
    ry: 0.424361,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 139.047C192.809 139.046 192.654 139.149 192.588 139.307C192.522 139.466 192.558 139.649 192.679 139.77C192.8 139.892 192.982 139.929 193.141 139.863C193.299 139.797 193.403 139.643 193.403 139.471C193.403 139.359 193.359 139.251 193.279 139.171C193.2 139.092 193.093 139.047 192.981 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 139.047C195.168 139.046 195.013 139.149 194.947 139.307C194.881 139.466 194.917 139.649 195.038 139.77C195.159 139.892 195.341 139.929 195.5 139.863C195.658 139.797 195.762 139.643 195.762 139.471C195.762 139.359 195.717 139.251 195.638 139.171C195.559 139.092 195.452 139.047 195.339 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 139.047C197.526 139.046 197.371 139.149 197.305 139.307C197.239 139.466 197.274 139.649 197.395 139.77C197.517 139.892 197.699 139.929 197.858 139.863C198.016 139.797 198.12 139.643 198.12 139.471C198.12 139.237 197.931 139.047 197.697 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 139.047C199.885 139.046 199.73 139.149 199.664 139.307C199.597 139.466 199.633 139.649 199.754 139.77C199.875 139.892 200.058 139.929 200.216 139.863C200.375 139.797 200.478 139.643 200.478 139.471C200.479 139.359 200.434 139.251 200.355 139.171C200.276 139.092 200.168 139.047 200.056 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 139.047C202.244 139.046 202.089 139.149 202.022 139.307C201.956 139.466 201.992 139.649 202.113 139.77C202.234 139.892 202.417 139.929 202.575 139.863C202.734 139.797 202.837 139.643 202.837 139.471C202.838 139.359 202.793 139.251 202.714 139.171C202.635 139.092 202.527 139.047 202.415 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 139.047C204.602 139.046 204.447 139.149 204.381 139.307C204.315 139.466 204.351 139.649 204.472 139.77C204.593 139.892 204.775 139.929 204.934 139.863C205.092 139.797 205.196 139.643 205.196 139.471C205.196 139.237 205.007 139.047 204.774 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 139.047C206.96 139.046 206.805 139.149 206.739 139.307C206.673 139.466 206.709 139.649 206.83 139.77C206.951 139.892 207.134 139.929 207.292 139.863C207.451 139.797 207.554 139.643 207.554 139.471C207.554 139.359 207.51 139.251 207.431 139.171C207.352 139.092 207.244 139.047 207.132 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 139.047C209.319 139.046 209.164 139.149 209.098 139.307C209.032 139.466 209.068 139.649 209.189 139.77C209.31 139.892 209.492 139.929 209.651 139.863C209.81 139.797 209.913 139.643 209.913 139.471C209.913 139.237 209.724 139.047 209.491 139.047Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 141.292C192.809 141.291 192.654 141.394 192.588 141.553C192.522 141.711 192.558 141.894 192.679 142.016C192.8 142.137 192.982 142.174 193.141 142.108C193.299 142.043 193.403 141.888 193.403 141.716C193.403 141.604 193.359 141.496 193.279 141.417C193.2 141.337 193.093 141.292 192.981 141.292Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 195.339,
    cy: 141.716,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.698 141.292C197.526 141.291 197.371 141.394 197.305 141.553C197.239 141.711 197.275 141.894 197.396 142.016C197.517 142.137 197.699 142.174 197.858 142.108C198.017 142.043 198.12 141.888 198.12 141.716C198.12 141.482 197.931 141.292 197.698 141.292Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.056,
    cy: 141.716,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 202.415,
    cy: 141.716,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.773,
    cy: 141.716,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 207.132,
    cy: 141.716,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 209.49,
    cy: 141.716,
    rx: 0.422128,
    ry: 0.424312,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 130.065C192.809 130.064 192.654 130.167 192.588 130.326C192.522 130.484 192.558 130.667 192.679 130.789C192.8 130.91 192.982 130.947 193.141 130.881C193.299 130.816 193.403 130.661 193.403 130.489C193.403 130.377 193.359 130.269 193.279 130.19C193.2 130.11 193.093 130.065 192.981 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 130.065C195.168 130.064 195.013 130.167 194.947 130.326C194.881 130.484 194.917 130.667 195.038 130.789C195.159 130.91 195.341 130.947 195.5 130.881C195.658 130.816 195.762 130.661 195.762 130.489C195.762 130.377 195.717 130.269 195.638 130.19C195.559 130.11 195.452 130.065 195.339 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 130.065C197.526 130.064 197.371 130.167 197.305 130.326C197.239 130.484 197.274 130.667 197.395 130.789C197.517 130.91 197.699 130.947 197.857 130.881C198.016 130.816 198.12 130.661 198.12 130.489C198.12 130.255 197.931 130.065 197.697 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 130.065C199.885 130.064 199.73 130.167 199.664 130.326C199.597 130.484 199.633 130.667 199.754 130.789C199.875 130.91 200.058 130.947 200.216 130.881C200.375 130.816 200.478 130.661 200.478 130.489C200.479 130.377 200.434 130.269 200.355 130.19C200.276 130.11 200.168 130.065 200.056 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 130.065C202.244 130.064 202.089 130.167 202.022 130.326C201.956 130.484 201.992 130.667 202.113 130.789C202.234 130.91 202.417 130.947 202.575 130.881C202.734 130.816 202.837 130.661 202.837 130.489C202.838 130.377 202.793 130.269 202.714 130.19C202.635 130.11 202.527 130.065 202.415 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 130.065C204.602 130.064 204.447 130.167 204.381 130.326C204.315 130.484 204.351 130.667 204.472 130.789C204.593 130.91 204.775 130.947 204.934 130.881C205.092 130.816 205.196 130.661 205.196 130.489C205.196 130.255 205.007 130.065 204.774 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 130.065C206.96 130.064 206.805 130.167 206.739 130.326C206.673 130.484 206.709 130.667 206.83 130.789C206.951 130.91 207.134 130.947 207.292 130.881C207.451 130.816 207.554 130.661 207.554 130.489C207.554 130.377 207.51 130.269 207.431 130.19C207.352 130.11 207.244 130.065 207.132 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 130.065C209.319 130.064 209.164 130.167 209.098 130.326C209.032 130.484 209.068 130.667 209.189 130.789C209.31 130.91 209.492 130.947 209.651 130.881C209.81 130.816 209.913 130.661 209.913 130.489C209.913 130.255 209.724 130.065 209.491 130.065Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 132.31C192.809 132.31 192.654 132.413 192.588 132.571C192.522 132.73 192.558 132.912 192.679 133.034C192.8 133.156 192.982 133.192 193.141 133.127C193.299 133.061 193.403 132.906 193.403 132.735C193.403 132.622 193.359 132.515 193.279 132.435C193.2 132.355 193.093 132.311 192.981 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 132.31C195.168 132.31 195.013 132.413 194.947 132.571C194.881 132.73 194.917 132.912 195.038 133.034C195.159 133.156 195.341 133.192 195.5 133.127C195.658 133.061 195.762 132.906 195.762 132.735C195.762 132.622 195.717 132.515 195.638 132.435C195.559 132.355 195.452 132.311 195.339 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 132.31C197.526 132.31 197.371 132.413 197.305 132.571C197.239 132.73 197.274 132.912 197.395 133.034C197.517 133.156 197.699 133.192 197.858 133.127C198.016 133.061 198.12 132.906 198.12 132.735C198.12 132.501 197.931 132.311 197.697 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 132.31C199.885 132.31 199.73 132.413 199.664 132.571C199.597 132.73 199.633 132.912 199.754 133.034C199.875 133.156 200.058 133.192 200.216 133.127C200.375 133.061 200.478 132.906 200.478 132.735C200.479 132.622 200.434 132.515 200.355 132.435C200.276 132.355 200.168 132.311 200.056 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 132.31C202.244 132.31 202.089 132.413 202.022 132.571C201.956 132.73 201.992 132.912 202.113 133.034C202.234 133.156 202.417 133.192 202.575 133.127C202.734 133.061 202.837 132.906 202.837 132.735C202.838 132.622 202.793 132.515 202.714 132.435C202.635 132.355 202.527 132.311 202.415 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 132.31C204.602 132.31 204.447 132.413 204.381 132.571C204.315 132.73 204.351 132.912 204.472 133.034C204.593 133.156 204.775 133.192 204.934 133.127C205.092 133.061 205.196 132.906 205.196 132.735C205.196 132.501 205.007 132.311 204.774 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 132.31C206.96 132.31 206.805 132.413 206.739 132.571C206.673 132.73 206.709 132.912 206.83 133.034C206.951 133.156 207.134 133.192 207.292 133.127C207.451 133.061 207.554 132.906 207.554 132.735C207.554 132.622 207.51 132.515 207.431 132.435C207.352 132.355 207.244 132.311 207.132 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 132.31C209.319 132.31 209.164 132.413 209.098 132.571C209.032 132.73 209.068 132.912 209.189 133.034C209.31 133.156 209.492 133.192 209.651 133.127C209.81 133.061 209.913 132.906 209.913 132.735C209.913 132.501 209.724 132.311 209.491 132.31Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 136.801C192.809 136.8 192.654 136.903 192.588 137.062C192.522 137.22 192.558 137.403 192.679 137.525C192.8 137.647 192.982 137.683 193.141 137.618C193.299 137.552 193.403 137.397 193.403 137.225C193.403 137.113 193.359 137.005 193.279 136.926C193.2 136.846 193.093 136.801 192.981 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 136.801C195.168 136.8 195.013 136.903 194.947 137.062C194.881 137.22 194.917 137.403 195.038 137.525C195.159 137.647 195.341 137.683 195.5 137.618C195.658 137.552 195.762 137.397 195.762 137.225C195.762 137.113 195.717 137.005 195.638 136.926C195.559 136.846 195.452 136.801 195.339 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 136.801C197.526 136.8 197.371 136.903 197.305 137.062C197.239 137.22 197.274 137.403 197.396 137.525C197.517 137.647 197.699 137.683 197.858 137.618C198.016 137.552 198.12 137.397 198.12 137.225C198.12 136.992 197.931 136.802 197.697 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 136.801C199.885 136.8 199.73 136.903 199.664 137.062C199.597 137.22 199.633 137.403 199.754 137.525C199.875 137.647 200.058 137.683 200.216 137.618C200.375 137.552 200.478 137.397 200.478 137.225C200.479 137.113 200.434 137.005 200.355 136.926C200.276 136.846 200.168 136.801 200.056 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 136.801C202.244 136.8 202.089 136.903 202.022 137.062C201.956 137.22 201.992 137.403 202.113 137.525C202.234 137.647 202.417 137.683 202.575 137.618C202.734 137.552 202.837 137.397 202.837 137.225C202.838 137.113 202.793 137.005 202.714 136.926C202.635 136.846 202.527 136.801 202.415 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 136.801C204.602 136.8 204.447 136.903 204.381 137.062C204.315 137.22 204.351 137.403 204.472 137.525C204.593 137.647 204.775 137.683 204.934 137.618C205.092 137.552 205.196 137.397 205.196 137.225C205.196 136.992 205.007 136.802 204.774 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 136.801C206.96 136.8 206.805 136.903 206.739 137.062C206.673 137.22 206.709 137.403 206.83 137.525C206.951 137.647 207.134 137.683 207.292 137.618C207.451 137.552 207.554 137.397 207.554 137.225C207.554 137.113 207.51 137.005 207.431 136.926C207.352 136.846 207.244 136.801 207.132 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 136.801C209.319 136.8 209.164 136.903 209.098 137.062C209.032 137.22 209.068 137.403 209.189 137.525C209.31 137.647 209.492 137.683 209.651 137.618C209.81 137.552 209.913 137.397 209.913 137.225C209.913 136.992 209.724 136.802 209.491 136.801Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.981 145.783C192.809 145.782 192.654 145.885 192.588 146.044C192.522 146.202 192.558 146.385 192.679 146.507C192.8 146.628 192.982 146.665 193.141 146.599C193.299 146.534 193.403 146.379 193.403 146.207C193.403 146.095 193.359 145.987 193.279 145.907C193.2 145.828 193.093 145.783 192.981 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.339 145.783C195.168 145.782 195.013 145.885 194.947 146.044C194.881 146.202 194.917 146.385 195.038 146.507C195.159 146.628 195.341 146.665 195.5 146.599C195.658 146.534 195.762 146.379 195.762 146.207C195.762 146.095 195.717 145.987 195.638 145.907C195.559 145.828 195.452 145.783 195.339 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.697 145.783C197.526 145.782 197.371 145.885 197.305 146.043C197.239 146.202 197.274 146.385 197.395 146.507C197.517 146.628 197.699 146.665 197.858 146.599C198.016 146.534 198.12 146.379 198.12 146.207C198.12 145.973 197.931 145.783 197.697 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.056 145.783C199.885 145.782 199.73 145.885 199.664 146.044C199.597 146.202 199.633 146.385 199.754 146.507C199.875 146.628 200.058 146.665 200.216 146.599C200.375 146.534 200.478 146.379 200.478 146.207C200.479 146.095 200.434 145.987 200.355 145.907C200.276 145.828 200.168 145.783 200.056 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.415 145.783C202.244 145.782 202.089 145.885 202.022 146.044C201.956 146.202 201.992 146.385 202.113 146.507C202.234 146.628 202.417 146.665 202.575 146.599C202.734 146.534 202.837 146.379 202.837 146.207C202.838 146.095 202.793 145.987 202.714 145.907C202.635 145.828 202.527 145.783 202.415 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.774 145.783C204.602 145.782 204.447 145.885 204.381 146.044C204.315 146.202 204.351 146.385 204.472 146.507C204.593 146.628 204.775 146.665 204.934 146.599C205.092 146.534 205.196 146.379 205.196 146.207C205.196 145.973 205.007 145.783 204.774 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.132 145.783C206.96 145.782 206.805 145.885 206.739 146.044C206.673 146.202 206.709 146.385 206.83 146.507C206.951 146.628 207.134 146.665 207.292 146.599C207.451 146.534 207.554 146.379 207.554 146.207C207.554 146.095 207.51 145.987 207.431 145.907C207.352 145.828 207.244 145.783 207.132 145.783Z",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.491 145.783C209.319 145.782 209.164 145.885 209.098 146.044C209.032 146.202 209.068 146.385 209.189 146.507C209.31 146.628 209.492 146.665 209.651 146.599C209.81 146.534 209.913 146.379 209.913 146.207C209.913 145.973 209.724 145.783 209.491 145.783Z",
    fill: "#0084F0"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M153.854 161.322L139.064 143.453L133.63 141.085C133.63 141.085 138.521 145.624 133.254 154.891C127.986 164.158 141.343 156.972 141.343 156.972",
    fill: "#004E9C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M165.048 132.669L171.24 140.015L176.782 142.953C176.782 142.953 174.36 137.776 175.301 132.669C176.242 127.563 167.211 132.953 167.211 132.953",
    fill: "#004E9C"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.859 173.868L84.7554 173.895L135.554 122.745L171.24 140.015L196.162 101.262L210.47 110.562L177.388 162.003L139.064 143.453L108.859 173.868V173.868Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.948 87.8026L181.843 96.6488L221.035 122.839L215.948 87.8026Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 87,
    width: 41,
    height: 36
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.948 87.8026L181.843 96.6488L221.035 122.839L215.948 87.8026Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.196 102.43C172.196 102.43 196.573 92.828 215.948 87.8026C222.698 86.0518 199.992 84.5841 199.286 85.0096C198.581 85.4352 176.993 90.2579 176.993 90.2579",
    fill: "#004E9C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.948 87.8026L181.843 96.6488L221.035 122.839L215.948 87.8026V87.8026Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M177.925 143.388L170.302 139.562L177.925 143.388Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M177.925 143.388L170.302 139.562",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M132.916 140.551L140.563 144.179L132.916 140.551Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.916 140.551L140.563 144.179",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M211.083 104.096L208.815 104.918",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154.65 142.384L160.539 145.02",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M109.498 86.5496V86.5473H103.52V72.8947C103.52 61.4633 94.0649 52.1759 82.4257 52.1759C70.7982 52.1759 61.3296 61.4755 61.3296 72.8969V86.5496H55.3513C52.482 86.5496 50.147 88.8444 50.147 91.6604V129.031C50.147 131.861 52.482 134.157 55.3513 134.157H109.498C112.379 134.157 114.705 131.862 114.705 129.031V91.6604C114.716 88.8444 112.379 86.5496 109.498 86.5496Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4348 86.5448V86.5496H69.4385V73.2356C69.4385 66.1885 75.2751 60.4575 82.4471 60.4575C89.621 60.4575 95.4464 66.1884 95.4464 73.2356L95.4348 86.5448Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.498 86.5496V86.5473H103.52V72.8947C103.52 61.4633 94.0649 52.1759 82.4257 52.1759C70.7982 52.1759 61.3296 61.4755 61.3296 72.8969V86.5496H55.3513C52.482 86.5496 50.147 88.8444 50.147 91.6604V129.031C50.147 131.861 52.482 134.157 55.3513 134.157H109.498C112.379 134.157 114.705 131.862 114.705 129.031V91.6604C114.716 88.8444 112.379 86.5496 109.498 86.5496Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.4348 86.5448V86.5496H69.4385V73.2356C69.4385 66.1885 75.2751 60.4575 82.4471 60.4575C89.621 60.4575 95.4464 66.1884 95.4464 73.2356L95.4348 86.5448Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3609 107.613V115.769C85.3537 116.143 85.0495 116.442 84.6767 116.442H80.1968C79.8247 116.441 79.5216 116.142 79.5143 115.769V107.613C77.4054 106.558 75.9487 104.433 75.9487 101.958C75.9487 98.4442 78.8507 95.5838 82.4375 95.5838C86.0228 95.5838 88.9248 98.4442 88.9248 101.955C88.9248 104.433 87.4696 106.558 85.3609 107.613Z",
    fill: "#004E9C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 75,
    y: 95,
    width: 14,
    height: 22
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3609 107.613V115.769C85.3537 116.143 85.0495 116.442 84.6767 116.442H80.1968C79.8247 116.441 79.5216 116.142 79.5143 115.769V107.613C77.4054 106.558 75.9487 104.433 75.9487 101.958C75.9487 98.4442 78.8507 95.5838 82.4375 95.5838C86.0228 95.5838 88.9248 98.4442 88.9248 101.955C88.9248 104.433 87.4696 106.558 85.3609 107.613Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.6949 107.613V115.769C83.6877 116.143 83.3835 116.442 83.0107 116.442H78.5308C78.1587 116.441 77.8556 116.142 77.8483 115.769V107.613C75.7394 106.558 74.2827 104.433 74.2827 101.958C74.2827 98.4442 77.1847 95.5838 80.7715 95.5838C84.3568 95.5838 87.2588 98.4442 87.2588 101.955C87.2588 104.433 85.8036 106.558 83.6949 107.613Z",
    fill: "white"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3609 107.613V115.769C85.3537 116.143 85.0495 116.442 84.6767 116.442H80.1968C79.8247 116.441 79.5216 116.142 79.5143 115.769V107.613C77.4054 106.558 75.9487 104.433 75.9487 101.958C75.9487 98.4442 78.8507 95.5838 82.4375 95.5838C86.0228 95.5838 88.9248 98.4442 88.9248 101.955C88.9248 104.433 87.4696 106.558 85.3609 107.613Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5434 91.1585C61.8628 92.6327 60.947 93.9862 59.832 95.1657",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.281 91.9959C106.548 92.855 105.733 93.6398 104.846 94.339",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M153.098 54.7422C157.877 51.7448 160.622 46.8958 161.805 45.9719C162.988 45.048 171.096 45.6414 171.73 44.9488C172.364 44.2562 171.122 47.3277 168.14 47.8521C165.158 48.3764 164.554 48.7125 164.554 48.7125C164.554 48.7125 161.847 55.8861 160.311 57.1936C158.775 58.5012 149.706 64.5643 149.706 64.5643L153.098 54.7422Z",
    fill: "white",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.763 52.3657C155.763 52.3657 160.918 59.0815 159.838 62.8567L127.766 76.9811L103.765 45.1437C103.765 45.1437 114.748 44.3429 117.596 44.0442C120.657 43.7231 130.497 61.0195 133.931 60.8784C135.647 60.8079 155.763 52.3657 155.763 52.3657Z",
    fill: "#004E9C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 44,
    width: 57,
    height: 33
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.763 52.3657C155.763 52.3657 160.918 59.0815 159.838 62.8567L127.766 76.9811L103.765 45.1437C103.765 45.1437 114.748 44.3429 117.596 44.0442C120.657 43.7231 130.497 61.0195 133.931 60.8784C135.647 60.8079 155.763 52.3657 155.763 52.3657Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.905 55.4863C130.784 72.0553 137.336 81.0352 147.953 68.4988L137.336 81.0352L114.208 78.147V73.0246",
    fill: "#004E9C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.127,
    cy: 60.5104,
    rx: 0.776035,
    ry: 0.780143,
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155.727,
    cy: 62.0782,
    rx: 0.776035,
    ry: 0.780143,
    fill: "#0084F0"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.763 52.3657C155.763 52.3657 160.918 59.0815 159.838 62.8567L127.766 76.9811L103.765 45.1437C103.765 45.1437 114.748 44.3429 117.596 44.0442C120.657 43.7231 130.497 61.0195 133.931 60.8784C135.647 60.8079 155.763 52.3657 155.763 52.3657Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M194.919 159.741L202.634 157.178L195.226 141.641L185.836 144.76L194.919 159.741Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 141,
    width: 18,
    height: 19
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.919 159.741L202.634 157.178L195.226 141.641L185.836 144.76L194.919 159.741Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.649 157.096C198.519 151.607 198.122 147.714 198.122 147.714L191.568 147L185.836 151.509",
    fill: "#004E9C"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.919 159.741L202.634 157.178L195.226 141.641L185.836 144.76L194.919 159.741V159.741Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M223.851 156.641C222.392 153.941 220.055 153.605 217.156 153.976C210.757 154.796 203.147 155.19 201.059 152.674L191.568 155.368L195.996 163.286C196.602 164.369 198.003 164.973 199.081 164.614L223.851 156.641Z",
    fill: "#0084F0",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M182.773 152.828C192.711 151.933 199.325 146.906 199.325 146.906L181.329 107.137C180.287 104.768 178.317 102.861 175.822 101.806L125.029 83.5547L126.177 87.2077L128.45 100.742L165.593 116.054L182.773 152.828Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.773 152.828C192.711 151.933 199.325 146.906 199.325 146.906L181.329 107.137C180.287 104.768 178.317 102.861 175.822 101.806L125.029 83.5547L126.177 87.2077L128.45 100.742L165.593 116.054L182.773 152.828Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M149.621 175.873L156.68 179.748L160.282 160.596L151.799 155.234L149.621 175.873Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 149,
    y: 155,
    width: 12,
    height: 25
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.621 175.873L156.68 179.748L160.282 160.596L151.799 155.234L149.621 175.873Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.965 166.261C156.246 170.133 159.34 168.163 159.34 168.163L153.651 163.712L146.115 164.251",
    fill: "#004E9C"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.621 175.873L156.68 179.748L160.282 160.596L151.799 155.234L149.621 175.873V175.873Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M169.298 195.623C170.515 192.867 169.289 190.861 167.141 188.849C162.4 184.406 157.223 178.773 157.892 175.643L149.683 169.946L147.879 179.748C147.403 180.868 147.819 182.314 148.793 182.93L169.298 195.623Z",
    fill: "#0084F0",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M146.252 162.907C146.252 162.907 156.953 170.537 162.081 167.411L169.261 113.879C169.78 110.207 167.829 106.516 164.359 104.608L125.029 83.5547L106.754 87.2154L105.593 91.745C103.702 99.1274 108.29 106.874 116.057 109.412L150.885 119.276L146.252 162.907Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 83,
    width: 65,
    height: 86
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.252 162.907C146.252 162.907 156.953 170.537 162.081 167.411L169.261 113.879C169.78 110.207 167.829 106.516 164.359 104.608L125.029 83.5547L106.754 87.2154L105.593 91.745C103.702 99.1274 108.29 106.874 116.057 109.412L150.885 119.276L146.252 162.907Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_5_1587)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.201,
    cy: 111.845,
    rx: 6.20826,
    ry: 1.84397,
    fill: "white",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.252 162.907C146.252 162.907 156.953 170.537 162.081 167.411L169.261 113.879C169.78 110.207 167.829 106.516 164.359 104.608L125.029 83.5547L106.754 87.2154L105.593 91.745C103.702 99.1274 108.29 106.874 116.057 109.412L150.885 119.276L146.252 162.907Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M115.144 44.6965C111.75 43.7294 98.2441 44.3353 96.6252 48.7785C95.9595 50.6056 91.2057 64.3161 100.087 101.816C105.749 105.438 130.112 83.7599 130.112 83.7599C130.18 83.7279 125.566 67.8024 121.212 56.2912",
    fill: "#004E9C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 44,
    width: 37,
    height: 59
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.144 44.6965C111.75 43.7294 98.2441 44.3353 96.6252 48.7785C95.9595 50.6056 91.2057 64.3161 100.087 101.816C105.749 105.438 130.112 83.7599 130.112 83.7599C130.18 83.7279 125.566 67.8024 121.212 56.2912",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.112 83.7599C94.9765 81.9767 95.5159 112.227 114.194 99.9122C132.871 87.5969 110.482 106.72 109.699 107.188C108.915 107.655 92.1887 110.457 92.1887 110.457L84.5645 89.6668C84.5645 89.6668 95.9058 75.0127 97.532 76.2701C99.1582 77.5274 125.873 77.7928 125.873 77.7928",
    fill: "#004E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.368 91.089C128.249 83.6186 113.854 48.7729 113.854 48.7729",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M115.144 44.6965C111.75 43.7294 98.2441 44.3353 96.6252 48.7785C95.9595 50.6056 91.2057 64.3161 100.087 101.816C105.749 105.438 130.112 83.7599 130.112 83.7599C130.18 83.7279 125.566 67.8024 121.212 56.2912",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M107.655 62.0782C106.397 70.6359 117.337 71.223 123.067 71.7325C128.796 72.242 115.63 72.1769 121.231 72.3658C126.832 72.5548 112.531 76.27 112.531 76.27L98.2441 75.0303L99.8066 63.7511L107.655 62.0782Z",
    fill: "#004E9C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130.764 73.3798C136.389 73.0821 141.126 70.1746 142.606 69.9419C144.086 69.7091 150.896 74.1734 151.784 73.8758C152.672 73.5782 150.106 75.6615 147.244 74.6694C144.383 73.6774 143.692 73.6774 143.692 73.6774C143.692 73.6774 137.869 78.6377 135.896 79.0345C133.922 79.4313 123.067 80.3242 123.067 80.3242L130.764 73.3798Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 123,
    y: 69,
    width: 29,
    height: 12
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.764 73.3798C136.389 73.0821 141.126 70.1746 142.606 69.9419C144.086 69.7091 150.896 74.1734 151.784 73.8758C152.672 73.5782 150.106 75.6615 147.244 74.6694C144.383 73.6774 143.692 73.6774 143.692 73.6774C143.692 73.6774 137.869 78.6377 135.896 79.0345C133.922 79.4313 123.067 80.3242 123.067 80.3242L130.764 73.3798Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.647 81.8074C136.535 74.9989 134.729 71.6568 134.729 71.6568L130.82 79.6088L134.833 82.2329",
    fill: "#004E9C"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.764 73.3798C136.389 73.0821 141.126 70.1746 142.606 69.9419C144.086 69.7091 150.896 74.1734 151.784 73.8758C152.672 73.5782 150.106 75.6615 147.244 74.6694C144.383 73.6774 143.692 73.6774 143.692 73.6774C143.692 73.6774 137.869 78.6377 135.896 79.0345C133.922 79.4313 123.067 80.3241 123.067 80.3241L130.764 73.3798Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M107.655 62.0782C106.489 66.5565 101.661 71.3727 101.661 71.3727L134.729 71.6568C134.729 71.6568 135.518 80.9821 132.755 83.7599H91.5783C88.5028 83.7562 85.788 81.7475 84.8814 78.8046C84.3756 77.1707 84.4778 75.4086 85.1693 73.8445L96.6253 48.7785",
    fill: "#004E9C"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M107.655 62.0782C106.489 66.5565 101.661 71.3727 101.661 71.3727L134.729 71.6568C134.729 71.6568 135.518 80.9821 132.755 83.7599H91.5783C88.5028 83.7562 85.788 81.7475 84.8814 78.8046V78.8046C84.3756 77.1707 84.4778 75.4086 85.1693 73.8445L96.6253 48.7785",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M139.077 79.5253L135.646 79.9563V78.9326L158.05 68.6414V70.0423L139.077 79.5253Z",
    fill: "#0084F0",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M158.05 37.7136V70.0423H182.705V45.4925C182.706 44.0614 181.81 42.7835 180.465 42.2994L161.281 35.4236C160.539 35.1593 159.715 35.2732 159.072 35.7289C158.429 36.1846 158.048 36.925 158.05 37.7136Z",
    fill: "#0084F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 158,
    y: 35,
    width: 25,
    height: 36
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.05 37.7136V70.0423H182.705V45.4925C182.706 44.0614 181.81 42.7835 180.465 42.2994L161.281 35.4236C160.539 35.1593 159.715 35.2732 159.072 35.7289C158.429 36.1846 158.048 36.925 158.05 37.7136Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.335 32.6648C201.792 58.4268 166.612 72.0438 166.612 72.0438L192.197 78.6632L195.207 54.052L184.672 40.7188",
    fill: "#0084F0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.051,
    cy: 53.4528,
    rx: 4.86081,
    ry: 4.88655,
    fill: "white",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.859 51.5477L173.387 54.4104L170.539 47.9042L177.011 45.0416L179.859 51.5477Z",
    fill: "#0084F0",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.413 60.2811L171.75 58.536L173.486 55.8585L176.149 57.6036L174.413 60.2811Z",
    fill: "#004E9C",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M158.05 37.7136V70.0423H182.705V45.4925C182.706 44.0614 181.81 42.7835 180.465 42.2994L161.281 35.4236C160.539 35.1593 159.715 35.2732 159.072 35.7289C158.429 36.1846 158.048 36.925 158.05 37.7136Z",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M135.646 79.9563L158.05 70.0423H182.704L159.765 80.4951L135.646 79.9563Z",
    fill: "#0084F0",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M113.855 48.7729L112.715 39.253L103.765 32.6648V45.1438",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 103,
    y: 32,
    width: 11,
    height: 17
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.855 48.7729L112.715 39.253L103.765 32.6648V45.1438",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_5_1587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.085 49.0974C112.437 45.0176 106.027 36.0248 106.027 36.0248L114.298 40.4597C114.298 40.4597 116.215 50.8382 115.085 49.0974Z",
    fill: "#004E9C"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M113.855 48.7729L112.715 39.253L103.765 32.6648V45.1438",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M103.254 33.9886L102.147 27.3407L117.037 25.4022C117.037 25.4022 118.646 35.8037 115.803 40.4068C114.079 43.1977 110.025 41.3987 107.099 39.5495",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_5_1587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 102,
    y: 25,
    width: 16,
    height: 17
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.254 33.9886L102.147 27.3407L117.037 25.4022C117.037 25.4022 118.646 35.8037 115.803 40.4068C114.079 43.1977 110.025 41.3987 107.099 39.5495",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_5_1587)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.27,
    cx: 119.033,
    cy: 35.5696,
    rx: 1.69362,
    ry: 2.27578,
    transform: "rotate(-68.5873 119.033 35.5696)",
    fill: "#004E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.126 36.3428C112.099 36.8583 112.439 37.3214 112.938 37.4491L112.126 36.3428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.126 36.3428C112.099 36.8583 112.439 37.3214 112.938 37.4491",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M103.254 33.9886L102.147 27.3407L117.037 25.4022C117.037 25.4022 118.646 35.8037 115.803 40.4068C114.079 43.1977 110.025 41.3987 107.099 39.5495",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M104.604 33.2822C113.194 34.2592 105.626 25.0607 117.037 26.3065C131.481 27.8835 127.946 20.3389 124.179 20.698C117.233 21.3602 127.586 18.8844 116.27 18.7004C111.227 18.6185 95.7315 21.3014 102.148 32.6648C104.583 36.9783 104.362 35.2747 104.604 33.2822Z",
    fill: "#0084F0",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M107.546 33.2175C107.382 32.7887 107.146 32.3907 106.85 32.0405C105.645 30.6053 103.713 30.1519 102.533 31.0278C101.354 31.9037 101.374 33.7772 102.578 35.2124C103.347 36.1285 104.412 36.6446 105.389 36.6703",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M107.546 33.2175C107.382 32.7887 107.146 32.3907 106.85 32.0405C105.645 30.6053 103.713 30.1519 102.533 31.0278C101.354 31.9037 101.374 33.7772 102.578 35.2124C103.347 36.1285 104.412 36.6446 105.389 36.6703",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M102.381 45.3265C102.381 45.3265 102.928 43.2225 103.765 42.8149L113.855 48.7729L113.007 50.5147L102.381 45.3265Z",
    fill: "#004E9C",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M115.144 50.0329L113.854 48.7729L113.389 42.464C114.678 42.6341 115.62 44.0397 115.62 44.0397L115.144 50.0329Z",
    fill: "#004E9C",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 129.824,
    cy: 81.089,
    rx: 0.776035,
    ry: 0.780143,
    fill: "#0084F0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.321,
    cy: 81.089,
    rx: 0.776035,
    ry: 0.780143,
    fill: "#0084F0"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M104.569 32.5788C104.174 32.7497 103.991 33.2895 104.2 33.6668",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M106.261 26.3373L106.543 26.621",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M116.067 22.3672C117.461 22.7838 118.927 22.9029 120.37 22.7168",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8433 71.2261C100.424 71.4685 101.065 71.5277 101.681 71.3959",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M134.012 61.0103L134.402 62.297",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M151.197 119.307C152.56 118.686 153.733 117.711 154.594 116.484",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M202.634 153.743C203.688 140.593 209.306 149.917 203.816 154.12C203.816 154.12 210.32 151.373 211.025 151.798",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M157.981 179.37C159.035 166.22 164.653 175.545 159.163 179.748C159.163 179.748 165.667 177 166.372 177.426",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M122.69 97.9964C124.974 99.1016 128.011 98.9318 130.109 97.5815",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M106.712 55.3533L106.141 57.0652",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M176.902 63.913L176.332 65.0543",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M194.593 38.2337L191.739 41.087",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M175.19 147.228L173.478 148.37",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1522 121.549L97.5815 124.402",
    stroke: "#0A193E",
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.4d1530f66d0155468120bb8f52e9d2f6.svg";
export { ForwardRef as ReactComponent };